import Vue from 'vue'
import Vuex from 'vuex'
import SAMPLE from './Sample'
import CAR from './Car'
import INSPECTION from './Inspection'
import PRICE from './Price'
import INSPECTION_SETTLEMENT from './InspectionSettlement'
import INSPECTION_SETTLEMENT_COMPLETE from './InspectionSettlementComplete'

Vue.use(Vuex)

const { MUTATION } = require('./mutation-types')
const { ACTION } = require('./action-types')

const state = {
  modals: []
}

const getters = {
  modals: (state) => {
    return state.modals
  }
}

const actions = {
  [ACTION.OPEN_MODAL] ({ commit }, params) {
    commit(MUTATION.OPEN_MODAL, params)
  },

  [ACTION.CLOSE_MODAL] ({ commit }) {
    commit(MUTATION.CLOSE_MODAL)
  }
}

const mutations = {
  [MUTATION.OPEN_MODAL] (state, modal) {
    state.modals.push(modal)
  },
  [MUTATION.CLOSE_MODAL] (state) {
    state.modals.pop()
  }
}

export default new Vuex.Store({
  modules: {
    SAMPLE,
    INSPECTION,
    CAR,
    PRICE,
    INSPECTION_SETTLEMENT,
    INSPECTION_SETTLEMENT_COMPLETE
  },
  state,
  getters,
  mutations,
  actions
})
